import { Typography, Box } from '@mui/material';

export const TextPartsLayout = ({
  parts,
  layout = 'stacked',
  containerStyle,
  inlineTypographyId,
}) => {
  return (
    <Box sx={{ ...containerStyle }}>
      {layout === 'inline' ? (
        <Typography id={inlineTypographyId} component="div">
          {parts.map((part, i) => (
            <Box key={part.key} component="span" sx={part.sx} id={part.id}>
              {part.text}
              {i < parts.length - 1 && ' '}
            </Box>
          ))}
        </Typography>
      ) : (
        parts.map(part => (
          <Typography key={part.key} sx={part.sx} id={part.id}>
            {part.text}
          </Typography>
        ))
      )}
    </Box>
  );
};
